import { ChevronLeftIcon, CheckCircleIcon, LockClosedIcon } from '@heroicons/react/solid';

export default function FormNavigation({ navigate, shouldShowCompletionCard, isFormLocked, isEditing, userType, handleSaveAndGoBack, dashboardPath: dashboardPathOverride }) {

    const dashboardPath = dashboardPathOverride || (userType === 'Informant' ? '/informant-dashboard' : '/patient-dashboard');
    
    const handleGoBack = async () => {
        // When the form is locked there is nothing to save — navigate straight
        // to the dashboard without attempting a Firestore write. Without this
        // guard the write hits the security rules rejection and the user sees a
        // spurious "We couldn't save your latest change" error toast.
        if (isFormLocked) {
            navigate(dashboardPath);
            return;
        }
        if (handleSaveAndGoBack) {
            await handleSaveAndGoBack();
        } else {
            navigate(dashboardPath);
        }
    };
        
    return (
        <nav id="form-navigation-container" aria-label="Form navigation" className="flex justify-between items-center px-2 md:px-4">
                    <button
                        onClick={handleGoBack}
                        aria-label={isFormLocked ? "Go back to dashboard" : "Save progress and go back to dashboard"}
                        className="flex items-center py-2 px-4 font-bold rounded-md shadow-md transition duration-100 bg-white text-gray-900 border border-gray-300 hover:bg-gray-50"
                    >
                        <ChevronLeftIcon className="w-5 h-5 mr-2" aria-hidden="true" />
                        {/* When locked there is nothing to save, so "Exit" is
                            more honest than "Save & Exit" on all breakpoints. */}
                        <span className={isFormLocked ? undefined : "hidden md:inline"}>
                            {isFormLocked ? 'Exit' : 'Save & Exit'}
                        </span>
                        {!isFormLocked && <span className="md:hidden">Exit</span>}
                    </button>

                    {isFormLocked ? (
                <div role="status" className="py-2 px-4 flex items-center font-bold rounded-md shadow-md bg-gray-200 text-gray-700 border border-gray-300">
                    <LockClosedIcon className="w-5 h-5 mr-2" aria-hidden="true" />
                    <span className="hidden md:inline">Form Locked</span>
                    <span className="md:hidden">Locked</span>
                </div>
            ) : (
                <button
                    className={`py-2 px-4 flex items-center font-bold rounded-md shadow-md transition duration-100 ml-4 a11y-focus-hide ${shouldShowCompletionCard && !isEditing ? 'bg-green-600 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                    disabled={!shouldShowCompletionCard || isEditing}
                    aria-disabled={!shouldShowCompletionCard || isEditing}
                    aria-label="Submit and complete this questionnaire"
                    onClick={() => navigate(dashboardPath)}
                >
                    <CheckCircleIcon className="w-5 h-5 mr-2" aria-hidden="true" />
                    <span className="hidden md:inline">Submit and Complete</span>
                    <span className="md:hidden">Complete</span>
                </button>
            )}
                </nav>
    );
}